import React, { FC } from 'react'
import { Link, Redirect } from 'react-router-dom'

const UserLink: FC<{
  params: { username: string }
}> = ({ params, children }) => {
  const { username } = params
  return (
    <Link
      target="_self"
      style={{ color: 'var(--accent)' }}
      onClick={() => <Redirect to={`/usr/${username}`} />}
      to={`/usr/${username}`}
    >
      {children}
    </Link>
  )
}

export default UserLink
